module.exports = __webpack_public_path__ + "assets/img/58_213_1.e53424fd.jpg";